module.exports = "<div class=\"discount-block\">\n    <div class=\"discount-block--item\" *ngFor=\"let item of negativeItems\">\n        <span><strong>{{ item.name }}</strong></span>\n        <span>{{ item.summary.priceWithCurrency.amountWithCurrency }}</span>\n    </div>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/quotes/common/discount-view-block/discount-view-block.component.html
// module id = ./web/modern/components/quotes/common/discount-view-block/discount-view-block.component.html
// module chunks = 0